import { render, staticRenderFns } from "./host-abstract.vue?vue&type=template&id=60d60126&"
import script from "./host-abstract.vue?vue&type=script&lang=js&"
export * from "./host-abstract.vue?vue&type=script&lang=js&"
import style0 from "./host-abstract.vue?vue&type=style&index=0&id=60d60126&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports